import React from 'react'
import { useFormContext } from 'react-hook-form'

import * as styles from './checkbox.module.scss'

type Props = {
  id: string
  label: string
  small?: boolean
}
const CheckboxToogle: React.FC<Props> = ({ id, label }) => {
  const {
    formState: { errors },
    register
  } = useFormContext()
  return (
    <div
      className={`${styles.itemChecboxToogle} ${errors[id] ? styles.errors : ''}`}
    >
      <label htmlFor={id} className={styles.boxcheckboxtoogle}>
        <input id={id} {...register(id)} type="checkbox" data-testid={id} />
        <span className={styles.toogle}></span>

        <div dangerouslySetInnerHTML={{ __html: label }} />
      </label>
      {errors[id] && (
        <span className={styles.errorToogle}>This field is mandatory</span>
      )}
    </div>
  )
}
export default CheckboxToogle
